import { render, staticRenderFns } from "./BalanceRecordForm.vue?vue&type=template&id=6daf7bf4&scoped=true&"
import script from "./BalanceRecordForm.vue?vue&type=script&lang=js&"
export * from "./BalanceRecordForm.vue?vue&type=script&lang=js&"
import style0 from "./BalanceRecordForm.vue?vue&type=style&index=0&id=6daf7bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daf7bf4",
  null
  
)

export default component.exports